import React from "react";
import classNames from "classnames";

import Radio from "./Radio";

const RadioGroup = ({
  id,
  value,
  error,
  touched,
  label,
  className,
  name,
  title,
  options,
  display,
  validate,
  ...rest
}) => {
  const classes = classNames(
    {
      "is-invalid": error && touched,
      error: error && touched,
    },
    className
  );

  let option_list = [];

  if (options) {
    for (let option of options) {
      const single_classes = classNames(
        "custom-control",
        "custom-radio",
        {
          "custom-control-inline": !(display && display === "block"),
          "is-invalid": error && touched,
          error: error && touched,
        },
        className
      );

      option_list.push(
        <Radio
          key={option.value}
          name={name}
          value={option.value}
          //checked={option.value === value}
          checked={option.value == value}
          label={option.label}
          error={error}
          touched={touched}
          className={single_classes}
          validate={validate}
          {...rest}
        />
      );
    }
  }

  return (
    <div className={classes}>
      {title && <h5 className="mt-3">{title}</h5>}
      <div className="mb-3">
        {option_list}
        {name && error && touched && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default RadioGroup;
